  <ng-template #Modal let-data let-ref="modalRef" >
    <nb-card  *ngIf="orderDetail" class="staffInfoTemplate " style="max-width: 800px">
      <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
        查看訂單
      </nb-card-header>
      
      <nb-card-body>

        <!-- 訂單資訊 -->
        <div class="row">
          <div class="col-sm-12 xd">
            <label class="label col-sm-12 col-form-label">訂單編號</label>
            <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.ORDNo"> -->
            <h6>{{orderDetail.EOSNo}}</h6>
          </div>

          <!-- <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">取餐號</label> -->
            <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.ORDNo"> -->
            <!-- <h6>{{orderDetail.PickupNumber}}</h6>
          </div> -->

          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">下單時間</label>
            <!-- <input nbInput disabled fullWidth [ngModel]="orderDetail.CreateDate"> -->
            <h6>{{orderDetail.CreateDate }}</h6>
          </div>

          <!-- <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">用餐方式</label>
            <h6>{{orderDetail.ORDKindName}}</h6> -->
            <!-- <nb-select name="orderType" [(ngModel)]="orderDetail.ORD_Kind_ID" disabled>
            <nb-option *ngFor="let e of ordTypeList" [value]="e.value">{{e.content}}</nb-option>
          </nb-select> -->
          <!-- </div> -->
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">訂單狀態</label>
            <h6>{{orderDetail.StatusName}}</h6>
            <!-- <nb-select name="ORD_Status_ID" [(ngModel)]="orderDetail.ORD_Status_ID" disabled>
            <nb-option *ngFor="let e of ORD_Status_List" [value]="e.value">{{e.content}}</nb-option>
          </nb-select> -->
          </div>


          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">門市名稱</label>
            <h6> {{ orderDetail.Name ? orderDetail.Name : '無'}}</h6>          
          </div>

          <div class="col-sm-6 xd" >
            <label class="label col-sm-12 col-form-label">門市電話</label>
            <h6> {{ orderDetail.Phone ? orderDetail.Phone : '無'}}</h6>          
          </div>

          <!-- <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID!=3">
            <label class="label col-sm-12 col-form-label">
              <span *ngIf="orderDetail.ORD_Kind_ID==1">外帶</span>
              <span *ngIf="orderDetail.ORD_Kind_ID==2">外送</span>
              <span *ngIf="orderDetail.ORD_Kind_ID==5">自取</span>時間
            </label>
            <h6>{{orderDetail.MealTime  ? orderDetail.MealTime : '無' }}</h6>
          </div> -->

          <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==2">
            <label class="label col-sm-12 col-form-label">外送地址</label>
            <h6> {{ orderDetail.Address ? orderDetail.Address : '無'}}</h6>          
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==3">
            <label class="label col-sm-12 col-form-label">內用桌號</label>
            <h6> {{ orderDetail.TableName ? orderDetail.TableName : '無'}}</h6>          
          </div>

          <div class="col-sm-6 xd" *ngIf="orderDetail.ORD_Kind_ID==3">
            <label class="label col-sm-12 col-form-label">內用人數 (大人 | 小孩)</label>
            <h6> {{ orderDetail.Adults }} | {{ orderDetail.Children }}</h6>          
          </div>

          <div class="col-sm-12 xd">
            <label class="label col-sm-12 col-form-label">備註</label>
            <h6> {{ orderDetail.Note ? orderDetail.Note : '無'}}</h6>
            <!-- <textarea rows="5" type="text" nbInput fullWidth [(ngModel)]="orderDetail.Note"> </textarea>-->
          
          </div>

        </div>
        <!-- 付款資訊 -->
        <div class="row">          
          <div class="titleHr">
            <span>付款資訊</span>
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">付款狀態</label>
            <h6>{{orderDetail.PayStatusName}}</h6>
            <!-- <nb-select name="ORD_PayStatus_ID" [(ngModel)]="orderDetail.ORD_PayStatus_ID" disabled>
            <nb-option *ngFor="let e of ORD_Pay_Status_List" [value]="e.value">{{e.content}}</nb-option>
          </nb-select> -->
          </div>

          <ng-container *ngFor="let e of orderDetail.PaymentKindData">
            <div class="col-sm-6 xd" >
              <label class="label col-sm-12 col-form-label">{{e.PaymentKindName}} : 實收 | 找零</label>
              <h6>{{e.ReceivedCash  | currency  : null : true :'1.0'}} | {{e.ChangeCash  | currency  : null : true :'1.0'}}</h6>          
            </div>
            <!-- <div class="col-sm-6 xd" *ngIf="e.SYS_PaymentKind_ID != 2">
              <label class="label col-sm-12 col-form-label">{{e.PaymentKindName}}支付</label>
              <h6>{{e.Cash  | currency  : null : true :'1.0'}}</h6>          
            </div> -->
          </ng-container>

          <!-- <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">支付方式</label>
            <h6>{{orderDetail.PaymentKindName}}</h6>          
          </div> -->


          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">小計</label>
            <h6> {{ orderDetail.Cash | currency  : null : true :'1.0'}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Cash" disabled> -->
          </div>
          <!-- <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">折扣</label>
            <h6> {{ orderDetail.DiscountCash | currency  : null : true :'1.0'}}</h6>
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">服務費</label>
            <h6> {{ orderDetail.ServiceFee | currency  : null : true :'1.0'}}</h6>
          </div> -->
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">運費</label>
            <h6> {{ orderDetail.ShippingFee | currency  : null : true :'1.0'}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ShippingFee" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">總計</label>
            <h6> {{ orderDetail.TotalCash | currency  : null : true :'1.0'}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
          </div>
        </div>

        <!-- 刷卡資訊 -->
        <div class="row" *ngIf="orderDetail.NCCCData != null">          
          <div class="titleHr">
            <span>刷卡資訊</span>
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">商店代號</label>
            <h6>{{orderDetail.NCCCData.MerchantID}}</h6>
          </div>

          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">端末機編號</label>
            <h6> {{ orderDetail.NCCCData.TerminalID}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.Cash" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">卡別</label>
            <h6> {{ orderDetail.NCCCData.CardType}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.DiscountCash" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">卡號</label>
            <h6> {{ orderDetail.NCCCData.CardNo}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ServiceFee" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">日期</label>
            <h6> {{ orderDetail.NCCCData.CreateDate}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.ShippingFee" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">授權碼</label>
            <h6> {{ orderDetail.NCCCData.ApprovalNo}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">調閱編號</label>
            <h6> {{ orderDetail.NCCCData.ReceiptNo}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">批次編號</label>
            <h6> {{ orderDetail.NCCCData.BatchNo}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
          </div>
          <div class="col-sm-6 xd">
            <label class="label col-sm-12 col-form-label">刷卡金額</label>
            <h6> {{ orderDetail.NCCCData.TransAmount}}</h6>
            <!-- <input nbInput disabled fullWidth [(ngModel)]="orderDetail.TotalCash" disabled> -->
          </div>
        </div>


        <!-- 商品詳情 -->

        <div class="row">          
          <div class="titleHr">
            <span>商品詳情</span>
          </div>
          <div class="col-xs-12" *ngFor="let group of orderDetail.GetEOSInfoProductGroupDTOs">
            <div *ngFor="let pd of group.GetEOSInfoProductDTOs; let index = index" class="mx-0 px-2 row">
              <div class="img-box" style="width: 200px; height: 200px;">
                <img [src]="pd.Image"> <!-- 加上默認圖片 -->
              </div>
          
              <div class="col-sm">
                <label class="label col-sm-12 col-form-label text-info">{{ pd.EOSProductName }} x {{ pd.Quantity }}</label>
                <label class="label col-sm-12 col-form-label text-org">
                  <span class="mr-3">價格: {{ pd.EOSProductCash | currency : null : true : '1.0' }} 元</span>
                  <!-- <span class="mr-3 text-hint">折扣: {{ pd.DiscountCash | currency : null : true : '1.0' }} 元</span> -->
                  <span class="mr-3">總計: {{ pd.ProductTotalCash | currency : null : true : '1.0' }} 元</span>
                </label>
                <div class="label col-sm-12 col-form-label" style="margin-left: -10px;">
                  <!-- 如果有額外資訊顯示模板 -->
                  <ng-container *ngIf="pd.EOSProductContant" [ngTemplateOutlet]="DeepShow" [ngTemplateOutletContext]="{ $implicit: pd }"></ng-container>
                </div>
                <label class="label col-sm-12 col-form-label text-danger">{{ pd.EOSProductAttachContant }}</label>
              </div>
            </div>
          </div>
          
        </div>


      </nb-card-body>
      <nb-card-footer>
        <div class="">
          <button nbButton (click)="onClose()">關閉</button>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>


  <ng-template #DeepShow let-pd>
    <div style="padding-left: 10px;" *ngFor="let a of pd.AttachItemList">
      • {{a.AttachItemName}} 
      <span *ngIf="a.AttachItemCash" class="text-org">{{a.AttachItemCash  | currency : null : true :'1.0'}}</span>
      <span *ngIf="a.AttachItemQuantity" >x {{a.AttachItemQuantity}}</span>                    
    </div>
    <div style="padding-left: 10px;" *ngFor="let pp of pd.PdList">
      • {{pp.ProductName}} 
      <span *ngIf="pp.ProductCash" class="text-org">{{pp.ProductCash  | currency : null : true :'1.0'}}</span>
      <span *ngIf="pp.Quantity" >x {{pp.Quantity}}</span>
        <div>
          <ng-container *ngIf="pp"
            [ngTemplateOutlet]="DeepShow" 
            [ngTemplateOutletContext]="{$implicit:pp} "                          
          ></ng-container>
        </div>                         
    </div>

 </ng-template> 